import React, { Component } from 'react';
import {
    Modal,
    Alert,
    Popover,
    OverlayTrigger,
    FormGroup,
    ControlLabel,
} from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import Validation from 'react-validation';

// To handle requests
import GroupsAPI from '../utils/GroupsAPI';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';
import { namespace } from '../../../config.json';


class CreateGroupButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            showValidation: true,
            groupname: '',
            modalErrorAlert: '',
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitGroup = this.submitGroup.bind(this);
    }

    componentWillMount() {
        // Setting validation rules for login form validation
        Object.assign(Validation.rules, {
            // Key name maps the rule
            required: {
                rule: value => (value.toString().trim()),
                hint: () => (<Alert
                  bsStyle="warning"
                  style={{ marginTop: '5px' }}>
                This field is required.
              </Alert>),
            },
            validGroupname: {
                rule: value => (this.groupnameValidator(value)),
                hint: () => (<Alert
                  bsStyle="info"
                  style={{ marginTop: '5px' }}>
                  {'Group names can contain upper and lowercase'}
                  <strong>{' alphanumeric characters with no spaces.'}</strong>
                  <br />
                   {'Group names may also include any '}
                   {'of the following characters:'}
                   <strong>{'  =,.@-_+'}</strong>.
                  <br />
                  {'It must have a : '}
                  <strong>
                    {'minimum length of 1 and a maximum length of 128.'}
                  </strong>
              </Alert>),
            },
        });
    }

    groupnameValidator(specGroupname) {
        const groupname = specGroupname || this.state.groupname;

        // Groupname is too long
        if (groupname.length > 128) {
            return false;
        }

        // String validation
        const validationRegEx = /^[a-zA-Z0-9=,.@\-_+]*$/;
        return groupname.match(validationRegEx);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({
            showModal: true,
            modalErrorAlert: '',
        });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            showModal: false,
            groupname: '',
            showValidation: false,
            modalErrorAlert: '',
        });
    }

    // Handle text input change to update state
    handleChange(e) {
        this.setState({ groupname: e.target.value });
    }

    // Fired when form is submitted
    submitGroup(e) {
        e.preventDefault();

        this.setState({
            modalErrorAlert: '',
            showValidation: false,
        });

        GroupsAPI.createGroup(this.state.groupname).then(res => {
            // Group has been created successfully
            if (res.group && res.group.GroupId) {
                const name = this.state.groupname;
                this.closeModal();
                // Calling specified callback if any
                if (this.props.callback) {
                    this.props.callback(name);
                }
            }
        }).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            } else if (message.status === 409) {
                this.setState({
                    modalErrorAlert:
                        `Group ${this.state.groupname} already exists.`,
                });
            } else if (message.status === 400) {
                this.setState({
                    modalErrorAlert:
                        `Group name ${this.state.groupname} is invalid.`,
                });
            } else {
                this.setState({
                    modalErrorAlert: `Unable to process the request as the
                                      server returned an Internal Error.`,
                });
            }
        });
    }

    render() {
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger">
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        const helpPopover = (
            <Popover id="popover-help-username" title="Naming restrictions">
                <p>Can contain upper and lowercase alphanumeric characters.</p>
                <p>Can also include any of the following characters: =,.@-_+</p>
                <p>Minimum length of 1, maximum length of 128</p>
            </Popover>
        );

        const helpIcon = (
            <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="right"
                overlay={helpPopover}>
                    <i className="fa fa-question-circle-o"></i>
            </OverlayTrigger>
        );

        return (
            <div>
                <button
                  className="btn btn-primary new-group-btn"
                  style={brandingStyles.buttons.primary}
                  onClick={this.openModal}
                >
                    <i className="fa fa-plus"></i>
                    <span>&nbsp;</span>
                    Create new group
                </button>

                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-users"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            Create new group
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                        <Validation.components.Form>

                            <div className="form-group">
                              <FormGroup
                                controlId="groupnameFormValidationError"
                                validationState={this.groupnameValidator()
                                  ? null : 'error'}>
                                <ControlLabel>
                                    Group name {helpIcon}
                                </ControlLabel>
                                <Validation.components.Input
                                  className="form-control"
                                  style={brandingStyles.backgrounds.input}
                                  type="text"
                                  value={this.state.groupname}
                                  onChange={this.handleChange}
                                  placeholder="Group name"
                                  name="groupname"
                                  validations={['required', 'validGroupname']}/>
                              </FormGroup>
                            </div>
                            { errorAlert }
                            <Validation.components.Button
                              onClick={this.submitGroup}
                              className="btn btn-primary pull-right"
                              style={brandingStyles.buttons.primary}
                            >
                                Submit
                            </Validation.components.Button>

                        </Validation.components.Form>
                        <div style={{
                            clear: 'both',
                        }}></div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }

}

CreateGroupButtonComponent.propTypes = {
    callback: PropTypes.func,
};

export default CreateGroupButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/CreateGroupButton.js
 **/